// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Button, Flex, Loading, Typography } from '@iheartjane/reefer';
import dompurify from 'dompurify';

import { useNavigateBack } from '@jane/shared/hooks';

import { Modal } from '../../components';
import { useTermsOfService } from '../../data-access';
import type { RootLoaderType } from '../../data-access';
import { useKioskSpacing, useTypedRouteLoaderData } from '../../hooks';

const StyledDiv = styled.div({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexGrow: 1,
});

export const TermsOfService = () => {
  const { getKioskSpacing, isIpad } = useKioskSpacing();
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');
  const goBack = useNavigateBack(`stores/${storeId}/menu`);
  const { data: termsOfService, isFetching } = useTermsOfService();

  return (
    <Modal
      appId="root"
      contentLabel="TermsOfService"
      onRequestClose={() => goBack()}
      open
      overlayClose
      variant="dialogue"
    >
      <Modal.Content>
        {isFetching ? (
          <Loading />
        ) : (
          <Flex flexDirection="column">
            <Typography variant="title-bold" mb={getKioskSpacing(24, 8)}>
              Terms of Service
            </Typography>
            <StyledDiv
              dangerouslySetInnerHTML={{
                __html: dompurify.sanitize(termsOfService?.text ?? ''),
              }}
            />
            <Button
              label="Close"
              onClick={() => goBack()}
              full
              branded
              size={isIpad ? 'small' : 'default'}
            />
          </Flex>
        )}
      </Modal.Content>
    </Modal>
  );
};
